<template>
  <div
    class="w-full h-full fixed left-0 top-0 alarm z-9999 pointer-events-none"
    :style="{ opacity: alarmOpacity ? 1 : 0, transition: `opacity ${frequency / 1000}s` }"
  ></div>
</template>

<script>
export default {
  name: 'AlarmFlicker',
  props: {
    frequency: {
      type: Number,
      defalut: 500, // 单位:ms
    },
    isFlicker: {
      type: Boolean,
      defalut: true,
    },
  },
  data() {
    return {
      alarmOpacity: false,
      flickerInterval: null,
    }
  },
  watch: {
    isFlicker(bol) {
      if (bol) {
        if (!this.flickerInterval) {
          this.flickerInterval = setInterval(() => {
            this.alarmOpacity = !this.alarmOpacity
          }, this.frequency)
        }
      } else if (this.flickerInterval) {
        clearInterval(this.flickerInterval)
        this.flickerInterval = null
      }
    },
  },
  mounted() {
    this.flickerInterval = setInterval(() => {
      this.alarmOpacity = !this.alarmOpacity
    }, this.frequency)
  },
  beforeDestroy() {
    if (this.flickerInterval) {
      clearInterval(this.flickerInterval)
      this.flickerInterval = null
    }
  },
}
</script>

<style lang="scss" scoped>
.alarm {
  background: linear-gradient(0deg, rgba(231, 56, 56, 0.01), rgba(231, 56, 56, 0.01));
  border: 2px solid #f72f2f;
  box-shadow: 1px 1px 50px 15px #e73838 inset;
}
</style>
